module.exports = __webpack_public_path__ + "2b4b8c8fbd44a9111d5030fc353916f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/search.png
// module id = 12
// module chunks = 0 1 2 3